import script from "./UserAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccount.vue?vue&type=script&setup=true&lang=js"

import "./UserAccount.vue?vue&type=style&index=0&id=b043a66a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b043a66a"]])

export default __exports__